import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if ([401, 403].includes(err.status)) {
                // El auto logout si error es 401 Unauthorized o 403 Forbidden i
                //this.authenticationService.logout();

                let error = { message: err.error, code: err.status }
                Swal.fire(
                    '¡Acceso no autorizado!',
                    'Está intentando ingresar a funciones no autorizadas. Su tiempo de sesión venció.',
                    'warning'
                );
                //return throwError(() => error);
                this.authenticationService.logout();
            }
            else if ([400].includes(err.status)) {
                let error = { message: err.error, code: err.status }
                return throwError(() => error);
            }
            else if ([429].includes(err.status)) {
                let error = { message: err.error, code: err.status }
                return throwError(() => error);
            }

            const error = err.error?.message || err.statusText;
            console.error(err);
            return throwError(() => error);
        }))
    }
}